import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=b636fc54&scoped=true&functional=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=b636fc54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b636fc54",
  null
  
)

export default component.exports